// data/languages/wolof/categories/grammaire.ts

import { GrammarCategory } from '../../../../types/types';

export const grammaire: GrammarCategory = {

  // ============================================================
  // UNITÉ 1 — PRONOMS, CLASSES NOMINALES & STRUCTURE
  // ============================================================

  'Pronoms personnels (ngi)': {
    'Maa ngi': {
      translation: "Je (en train de)",
      translationEn: "I (in the process of)",
      explanation: "Utilisé pour exprimer une action en cours",
      explanationEn: "Used to express an action in progress",
      example: "Maa ngi jàng. (Je suis en train d'étudier.)",
      exampleEn: "Maa ngi jàng. (I am studying.)",
      audio: "Wf-maa_ngi"
    },
    'Yaa ngi': {
      translation: "Tu (en train de)",
      translationEn: "You (in the process of)",
      explanation: "Deuxième personne du singulier, action en cours",
      explanationEn: "Second person singular, action in progress",
      example: "Yaa ngi liggéey. (Tu es en train de travailler.)",
      exampleEn: "Yaa ngi liggéey. (You are working.)",
      audio: "Wf-yaa_ngi"
    },
    'Mu ngi': {
      translation: "Il/Elle (en train de)",
      translationEn: "He/She (in the process of)",
      explanation: "Troisième personne du singulier, action en cours",
      explanationEn: "Third person singular, action in progress",
      example: "Mu ngi lekk. (Il/Elle est en train de manger.)",
      exampleEn: "Mu ngi lekk. (He/She is eating.)",
      audio: "Wf-mu_ngi"
    },
    'Nu ngi': {
      translation: "Nous (en train de)",
      translationEn: "We (in the process of)",
      explanation: "Première personne du pluriel, action en cours",
      explanationEn: "First person plural, action in progress",
      example: "Nu ngi dem. (Nous sommes en train de partir.)",
      exampleEn: "Nu ngi dem. (We are leaving.)"
    },
    'Yeena ngi': {
      translation: "Vous (en train de)",
      translationEn: "You (plural, in the process of)",
      explanation: "Deuxième personne du pluriel, action en cours",
      explanationEn: "Second person plural, action in progress",
      example: "Yeena ngi ñëw. (Vous êtes en train de venir.)",
      exampleEn: "Yeena ngi ñëw. (You are coming.)"
    },
    'Ñu ngi': {
      translation: "Ils/Elles (en train de)",
      translationEn: "They (in the process of)",
      explanation: "Troisième personne du pluriel, action en cours",
      explanationEn: "Third person plural, action in progress",
      example: "Ñu ngi toog. (Ils/Elles sont en train de s'asseoir.)",
      exampleEn: "Ñu ngi toog. (They are sitting down.)"
    },
  },

  'Pronoms emphatiques': {
    'Maa': {
      translation: "Je (emphatique)",
      translationEn: "I (emphatic)",
      explanation: "Utilisé pour mettre l'accent sur le sujet",
      explanationEn: "Used to emphasize the subject",
      example: "Maa ko def. (C'est moi qui l'ai fait.)",
      exampleEn: "Maa ko def. (It is I who did it.)",
      audio: "Wf-maa"
    },
    'Yaa': {
      translation: "Tu (emphatique)",
      translationEn: "You (emphatic)",
      explanation: "Deuxième personne du singulier, emphatique",
      explanationEn: "Second person singular, emphatic",
      example: "Yaa ma woo. (C'est toi qui m'as appelé.)",
      exampleEn: "Yaa ma woo. (It is you who called me.)"
    },
    'Moom': {
      translation: "Lui/Elle (emphatique)",
      translationEn: "Him/Her (emphatic)",
      explanation: "Troisième personne du singulier, emphatique",
      explanationEn: "Third person singular, emphatic",
      example: "Moom moo dem. (C'est lui/elle qui est parti(e).)",
      exampleEn: "Moom moo dem. (It is he/she who left.)",
      audio: "Wf-moom"
    },
    'Nun': {
      translation: "Nous (emphatique)",
      translationEn: "We (emphatic)",
      explanation: "Première personne du pluriel, emphatique",
      explanationEn: "First person plural, emphatic",
      example: "Nun ñoo ko xam. (C'est nous qui le savons.)",
      exampleEn: "Nun ñoo ko xam. (It is we who know it.)"
    },
    'Yeen': {
      translation: "Vous (emphatique)",
      translationEn: "You (plural, emphatic)",
      explanation: "Deuxième personne du pluriel, emphatique",
      explanationEn: "Second person plural, emphatic",
      example: "Yeen yeena ko wax. (C'est vous qui l'avez dit.)",
      exampleEn: "Yeen yeena ko wax. (It is you who said it.)",
      audio: "Wf-yeen"
    },
    'Ñoom': {
      translation: "Eux/Elles (emphatique)",
      translationEn: "Them (emphatic)",
      explanation: "Troisième personne du pluriel, emphatique",
      explanationEn: "Third person plural, emphatic",
      example: "Ñoom ñoo ko bëgg. (Ce sont eux/elles qui le veulent.)",
      exampleEn: "Ñoom ñoo ko bëgg. (It is they who want it.)"
    },
  },

  'Pronoms objets': {
    'Ma': {
      translation: "Me/Moi (objet)",
      translationEn: "Me (object)",
      explanation: "Utilisé comme objet direct ou indirect à la 1re personne du singulier",
      explanationEn: "Used as a direct or indirect object in the 1st person singular",
      example: "Dimbal ma. (Aide-moi.)",
      exampleEn: "Dimbal ma. (Help me.)",
      audio: "Wf-ma"
    },
    'La': {
      translation: "Te/Toi (objet)",
      translationEn: "You (object)",
      explanation: "Deuxième personne du singulier, objet direct ou indirect",
      explanationEn: "Second person singular, direct or indirect object",
      example: "Dama la gis. (Je t'ai vu.)",
      exampleEn: "Dama la gis. (I saw you.)",
      audio: "Wf-la"
    },
    'Ko': {
      translation: "Le/La/Lui (objet)",
      translationEn: "Him/Her/It (object)",
      explanation: "Troisième personne du singulier, objet direct ou indirect",
      explanationEn: "Third person singular, direct or indirect object",
      example: "Dama ko jox. (Je le/la lui ai donné.)",
      exampleEn: "Dama ko jox. (I gave it to him/her.)",
      audio: "Wf-ko"
    },
    'Nu': {
      translation: "Nous (objet)",
      translationEn: "Us (object)",
      explanation: "Première personne du pluriel, objet direct ou indirect",
      explanationEn: "First person plural, direct or indirect object",
      example: "Woo nu. (Appelle-nous.)",
      exampleEn: "Woo nu. (Call us.)"
    },
    'Leen': {
      translation: "Vous (objet pluriel)",
      translationEn: "You (plural object)",
      explanation: "Deuxième personne du pluriel, objet direct ou indirect",
      explanationEn: "Second person plural, direct or indirect object",
      example: "Dama leen gis. (Je vous ai vus.)",
      exampleEn: "Dama leen gis. (I saw you [plural].)",
      audio: "Wf-leen"
    },
    'Léen': {
      translation: "Les/Leur (objet)",
      translationEn: "Them (object)",
      explanation: "Troisième personne du pluriel, objet direct ou indirect",
      explanationEn: "Third person plural, direct or indirect object",
      example: "Dama léen wax. (Je leur ai parlé.)",
      exampleEn: "Dama léen wax. (I spoke to them.)"
    },
  },

  'Pronoms possessifs': {
    'Sama': {
      translation: "Mon/Ma",
      translationEn: "My",
      explanation: "Possessif première personne du singulier",
      explanationEn: "First person singular possessive",
      example: "Sama kër. (Ma maison.)",
      exampleEn: "Sama kër. (My house.)"
    },
    'Sa': {
      translation: "Ton/Ta",
      translationEn: "Your",
      explanation: "Possessif deuxième personne du singulier",
      explanationEn: "Second person singular possessive",
      example: "Sa xarit. (Ton ami.)",
      exampleEn: "Sa xarit. (Your friend.)"
    },
    'Borom': {
      translation: "Son/Sa",
      translationEn: "His/Her",
      explanation: "Possessif troisième personne du singulier",
      explanationEn: "Third person singular possessive",
      example: "Borom xam-xam. (Son savoir.)",
      exampleEn: "Borom xam-xam. (His/Her knowledge.)",
      audio: "Wf-borom"
    },
    'Sunu': {
      translation: "Notre",
      translationEn: "Our",
      explanation: "Possessif première personne du pluriel",
      explanationEn: "First person plural possessive",
      example: "Sunu réew. (Notre pays.)",
      exampleEn: "Sunu réew. (Our country.)",
      audio: "Wf-sunu"
    },
    'Seen': {
      translation: "Votre",
      translationEn: "Your (plural)",
      explanation: "Possessif deuxième personne du pluriel",
      explanationEn: "Second person plural possessive",
      example: "Seen tool. (Votre champ.)",
      exampleEn: "Seen tool. (Your field.)"
    },
    'Séen': {
      translation: "Leur",
      translationEn: "Their",
      explanation: "Possessif troisième personne du pluriel",
      explanationEn: "Third person plural possessive",
      example: "Séen waa kër. (Leur famille.)",
      exampleEn: "Séen waa kër. (Their family.)"
    },
  },

  'Pronoms toniques': {
    'Man': {
      translation: "Moi",
      translationEn: "Me",
      explanation: "Pronom tonique première personne du singulier",
      explanationEn: "First person singular tonic pronoun",
      example: "Man laa ko def. (C'est moi qui l'ai fait.)",
      exampleEn: "Man laa ko def. (It is I who did it.)",
      audio: "Wf-man"
    },
    'Yow': {
      translation: "Toi",
      translationEn: "You",
      explanation: "Pronom tonique deuxième personne du singulier",
      explanationEn: "Second person singular tonic pronoun",
      example: "Yow rekk. (Toi seul.)",
      exampleEn: "Yow rekk. (You alone.)"
    },
    'Môom': {
      translation: "Lui/Elle",
      translationEn: "Him/Her",
      explanation: "Pronom tonique troisième personne du singulier",
      explanationEn: "Third person singular tonic pronoun",
      example: "Môom la wax. (C'est lui/elle qui a parlé.)",
      exampleEn: "Môom la wax. (It is he/she who spoke.)",
      audio: "Wf-moom"
    },
    'Nûn': {
      translation: "Nous",
      translationEn: "Us",
      explanation: "Pronom tonique première personne du pluriel",
      explanationEn: "First person plural tonic pronoun",
      example: "Nûn ñëpp. (Nous tous.)",
      exampleEn: "Nûn ñëpp. (All of us.)"
    },
    'Yéen': {
      translation: "Vous",
      translationEn: "You (plural)",
      explanation: "Pronom tonique deuxième personne du pluriel",
      explanationEn: "Second person plural tonic pronoun",
      example: "Yéen ñépp. (Vous tous.)",
      exampleEn: "Yéen ñépp. (All of you.)",
      audio: "Wf-yeen"
    },
    'Ñôom': {
      translation: "Eux/Elles",
      translationEn: "Them",
      explanation: "Pronom tonique troisième personne du pluriel",
      explanationEn: "Third person plural tonic pronoun",
      example: "Ñôom ñoo fa dem. (Ce sont eux/elles qui y sont allés.)",
      exampleEn: "Ñôom ñoo fa dem. (It is they who went there.)"
    },
  },

  'Pronoms focus verbal (Da-)': {
    'Dama': {
      translation: "Je (focus action)",
      translationEn: "I (action focus)",
      explanation: "Particule 'da-' + '-ma' : met le focus sur l'action accomplie par le sujet.",
      explanationEn: "Particle 'da-' + '-ma': puts the focus on the action performed by the subject.",
      example: "Dama lekk. (Je mange / C'est moi qui mange.)",
      exampleEn: "Dama lekk. (I am eating / It is I who is eating.)",
      audio: "Wf-dama"
    },
    'Danga': {
      translation: "Tu (focus action)",
      translationEn: "You (action focus)",
      explanation: "Particule 'da-' + '-nga' : focus verbal à la 2e personne du singulier.",
      explanationEn: "Particle 'da-' + '-nga': verbal focus in the 2nd person singular.",
      example: "Danga dem. (Tu pars / C'est toi qui pars.)",
      exampleEn: "Danga dem. (You are leaving / It is you who is leaving.)"
    },
    'Dafa': {
      translation: "Il/Elle (focus action)",
      translationEn: "He/She (action focus)",
      explanation: "Particule 'da-' + '-fa' : focus verbal à la 3e personne du singulier.",
      explanationEn: "Particle 'da-' + '-fa': verbal focus in the 3rd person singular.",
      example: "Dafa jàng. (Il/Elle étudie / C'est lui/elle qui étudie.)",
      exampleEn: "Dafa jàng. (He/She is studying / It is he/she who is studying.)",
      audio: "Wf-dafa"
    },
    'Danu': {
      translation: "Nous (focus action)",
      translationEn: "We (action focus)",
      explanation: "Particule 'da-' + '-nu' : focus verbal à la 1re personne du pluriel.",
      explanationEn: "Particle 'da-' + '-nu': verbal focus in the 1st person plural.",
      example: "Danu dem. (Nous partons / C'est nous qui partons.)",
      exampleEn: "Danu dem. (We are leaving / It is we who are leaving.)"
    },
    'Dangeen': {
      translation: "Vous (focus action)",
      translationEn: "You (plural, action focus)",
      explanation: "Particule 'da-' + '-ngeen' : focus verbal à la 2e personne du pluriel.",
      explanationEn: "Particle 'da-' + '-ngeen': verbal focus in the 2nd person plural.",
      example: "Dangeen xam. (Vous savez / C'est vous qui savez.)",
      exampleEn: "Dangeen xam. (You know / It is you who knows.)"
    },
    'Dañu': {
      translation: "Ils/Elles (focus action)",
      translationEn: "They (action focus)",
      explanation: "Particule 'da-' + '-ñu' : focus verbal à la 3e personne du pluriel.",
      explanationEn: "Particle 'da-' + '-ñu': verbal focus in the 3rd person plural.",
      example: "Dañu dem. (Ils/Elles partent / Ce sont eux/elles qui partent.)",
      exampleEn: "Dañu dem. (They are leaving / It is they who are leaving.)"
    },
  },

  'Classes nominales': {
    'Classe B (bi/ba/bu)': {
      translation: "Article défini — objets courants",
      translationEn: "Definite article — common objects",
      explanation: "La classe B couvre la majorité des objets inanimés. 'Bi' = défini proximal, 'ba' = défini distal, 'bu' = indéfini relatif.",
      explanationEn: "Class B covers most inanimate objects. 'Bi' = proximal definite, 'ba' = distal definite, 'bu' = relative indefinite.",
      example: "Taabal bi. (La table.) / Téere ba. (Ce livre-là.)",
      exampleEn: "Taabal bi. (The table.) / Téere ba. (That book.)"
    },
    'Classe G (gi/ga/gu)': {
      translation: "Article défini — arbres, lieux, abstraits",
      translationEn: "Definite article — trees, places, abstract concepts",
      explanation: "La classe G regroupe les arbres, certains lieux et concepts abstraits.",
      explanationEn: "Class G groups together trees, certain places, and abstract concepts.",
      example: "Garab gi. (L'arbre.) / Suuf ga. (La terre.)",
      exampleEn: "Garab gi. (The tree.) / Suuf ga. (The land.)"
    },
    'Classe M (mi/ma/mu)': {
      translation: "Article défini — liquides, corps",
      translationEn: "Definite article — liquids, bodily substances",
      explanation: "La classe M couvre les liquides, certaines parties du corps et denrées alimentaires.",
      explanationEn: "Class M covers liquids, certain body parts, and food items.",
      example: "Ndox mi. (L'eau.) / Ceeb mi. (Le riz.)",
      exampleEn: "Ndox mi. (The water.) / Ceeb mi. (The rice.)"
    },
    'Classe W (wi/wa/wu)': {
      translation: "Article défini — personnes",
      translationEn: "Definite article — people",
      explanation: "La classe W est principalement réservée aux êtres humains au singulier.",
      explanationEn: "Class W is mainly reserved for human beings in the singular.",
      example: "Góor wi. (L'homme.) / Jigéen wi. (La femme.)",
      exampleEn: "Góor wi. (The man.) / Jigéen wi. (The woman.)"
    },
    'Classe K (ki/ka/ku)': {
      translation: "Article défini — personne précise",
      translationEn: "Definite article — specific person",
      explanation: "La classe K désigne une personne précise, identifiée dans le contexte.",
      explanationEn: "Class K designates a specific person, identified within the context.",
      example: "Nit ki. (Cette personne.) / Xale ki. (Cet enfant.)",
      exampleEn: "Nit ki. (This person.) / Xale ki. (This child.)"
    },
    'Classe Y (yi/ya/yu)': {
      translation: "Article défini — pluriel",
      translationEn: "Definite article — plural",
      explanation: "La classe Y marque le pluriel pour la plupart des classes nominales.",
      explanationEn: "Class Y marks the plural for most noun classes.",
      example: "Nit ñi. (Les gens.) / Téere yi. (Les livres.)",
      exampleEn: "Nit ñi. (The people.) / Téere yi. (The books.)"
    },
  },

  'Structure de la phrase': {
    'Ordre neutre': {
      translation: "Sujet + Marqueur + Verbe",
      translationEn: "Subject + Marker + Verb",
      explanation: "En wolof, le marqueur de focus se place entre le sujet et le verbe. L'ordre de base est : Sujet — Marqueur de focus — Verbe — Complément.",
      explanationEn: "In Wolof, the focus marker is placed between the subject and the verb. The basic order is: Subject — Focus marker — Verb — Object.",
      example: "Maa ngi lekk ceeb. (Je mange du riz — sujet + ngi + verbe + COD.)",
      exampleEn: "Maa ngi lekk ceeb. (I am eating rice — subject + ngi + verb + object.)"
    },
    'Focus sujet (moo)': {
      translation: "C'est [sujet] qui...",
      translationEn: "It is [subject] who...",
      explanation: "Pour mettre le sujet en focus, on utilise 'moo' (3sg) ou les formes emphatiques. La proposition met en relief QUI fait l'action.",
      explanationEn: "To put the subject in focus, 'moo' (3sg) or the emphatic forms are used. The clause highlights WHO performs the action.",
      example: "Moom moo dem. (C'est LUI qui est parti — pas quelqu'un d'autre.)",
      exampleEn: "Moom moo dem. (It is HE who left — not someone else.)"
    },
    'Focus verbe (da-)': {
      translation: "Ce que [sujet] FAIT, c'est...",
      translationEn: "What [subject] DOES is...",
      explanation: "Le préfixe 'da-' met en relief l'ACTION elle-même, pas le sujet ni le complément.",
      explanationEn: "The prefix 'da-' highlights the ACTION itself, not the subject or the object.",
      example: "Dafa jàng. (Ce qu'il fait, c'est ÉTUDIER.)",
      exampleEn: "Dafa jàng. (What he is doing is STUDYING.)"
    },
    'Focus complément (la)': {
      translation: "C'est [complément] que...",
      translationEn: "It is [object] that...",
      explanation: "'La' (ou 'laa/nga/na...') met en focus le complément d'objet. On répond à la question 'Qu'est-ce que ?'.",
      explanationEn: "'La' (or 'laa/nga/na...') puts the object complement in focus. It answers the question 'What?'.",
      example: "Ceeb laa lekk. (C'est du RIZ que je mange — pas autre chose.)",
      exampleEn: "Ceeb laa lekk. (It is RICE that I am eating — not something else.)"
    },
    'Présentatif (ngi)': {
      translation: "Voilà / Il y a [sujet qui fait]",
      translationEn: "Here is / There is [subject doing]",
      explanation: "'Ngi' présente le sujet en train d'agir, comme un présentatif d'action en cours. Très courant pour situer quelqu'un.",
      explanationEn: "'Ngi' presents the subject in the act of doing something, like a presentative for an action in progress. Very common for locating someone.",
      example: "Mu ngi fi. (Il/Elle est ici. / Le voilà.)",
      exampleEn: "Mu ngi fi. (He/She is here. / There he/she is.)"
    },
    'Verbe copule (di)': {
      translation: "Être / C'est",
      translationEn: "To be / It is",
      explanation: "'Di' sert de copule (équivalent du verbe 'être') devant un nom ou un adjectif attribut.",
      explanationEn: "'Di' serves as a copula (equivalent of the verb 'to be') before a predicate noun or adjective.",
      example: "Dama di jàngalekat. (Je suis enseignant.)",
      exampleEn: "Dama di jàngalekat. (I am a teacher.)"
    },
  },

  // ============================================================
  // UNITÉ 2 — TEMPS VERBAUX, NÉGATION & QUESTIONS
  // ============================================================

  'Temps verbaux — Présent': {
    'Damay dem': {
      translation: "Je vais (habituellement)",
      translationEn: "I go (habitually)",
      explanation: "Présent habituel 1re personne. 'Dama + y + verbe' exprime une action régulière ou un état permanent.",
      explanationEn: "Habitual present, 1st person. 'Dama + y + verb' expresses a regular action or a permanent state.",
      example: "Damay dem jumaa. (Je vais habituellement à la mosquée du vendredi.)",
      exampleEn: "Damay dem jumaa. (I usually go to the Friday mosque.)",
      audio: "Wf-damay_dem"
    },
    'Dangay dem': {
      translation: "Tu vas (habituellement)",
      translationEn: "You go (habitually)",
      explanation: "Présent habituel 2e personne du singulier.",
      explanationEn: "Habitual present, 2nd person singular.",
      example: "Dangay jàng ci kanam? (Tu étudies d'habitude le matin ?)",
      exampleEn: "Dangay jàng ci kanam? (Do you usually study in the morning?)"
    },
    'Dafay dem': {
      translation: "Il/Elle va (habituellement)",
      translationEn: "He/She goes (habitually)",
      explanation: "Présent habituel 3e personne du singulier.",
      explanationEn: "Habitual present, 3rd person singular.",
      example: "Dafay lekk ceeb. (Il/Elle mange habituellement du riz.)",
      exampleEn: "Dafay lekk ceeb. (He/She usually eats rice.)"
    },
    'Dafa doon dem': {
      translation: "Il/Elle était en train d'aller",
      translationEn: "He/She was going",
      explanation: "Imparfait progressif — action en cours dans le passé. Formé avec 'doon' (auxiliaire d'imparfait).",
      explanationEn: "Progressive imperfect — action in progress in the past. Formed with 'doon' (imperfect auxiliary).",
      example: "Dafa doon dem bi telefon bi sonnee. (Il/Elle était en train de partir quand le téléphone a sonné.)",
      exampleEn: "Dafa doon dem bi telefon bi sonnee. (He/She was leaving when the phone rang.)",
      audio: "Wf-dafa_doon_dem"
    },
    'Maa ngi dem': {
      translation: "Je suis en train d'aller",
      translationEn: "I am going",
      explanation: "Présent progressif 1re personne, équivalent du présent continu français.",
      explanationEn: "Progressive present, 1st person, equivalent of the French present continuous.",
      example: "Maa ngi dem sama kër. (Je suis en train de rentrer chez moi.)",
      exampleEn: "Maa ngi dem sama kër. (I am on my way home.)",
      audio: "Wf-maa_ngi_dem"
    },
    'Mu ngi dem': {
      translation: "Il/Elle est en train d'aller",
      translationEn: "He/She is going",
      explanation: "Présent progressif 3e personne du singulier.",
      explanationEn: "Progressive present, 3rd person singular.",
      example: "Mu ngi dem liggéeyu. (Il/Elle est en train d'aller travailler.)",
      exampleEn: "Mu ngi dem liggéeyu. (He/She is on the way to work.)",
      audio: "Wf-mu_ngi_dem"
    },
  },

  'Temps verbaux — Passé': {
    // ── Passé résultatif (na) ── action accomplie, résultat encore pertinent
    'Naa dem': {
      translation: "Je suis allé(e)",
      translationEn: "I went",
      explanation: "Passé résultatif 1re personne du singulier. 'Naa' = 'na' + clitique '-a' (1sg).",
      explanationEn: "Resultative past, 1st person singular. 'Naa' = 'na' + clitic '-a' (1sg).",
      example: "Naa dem Ndakaaru démb. (Je suis allé(e) à Dakar hier.)",
      exampleEn: "Naa dem Ndakaaru démb. (I went to Dakar yesterday.)"
    },
    'Dem nga': {
      translation: "Tu es allé(e)",
      translationEn: "You went",
      explanation: "Passé résultatif 2e personne du singulier.",
      explanationEn: "Resultative past, 2nd person singular.",
      example: "Dem nga fa démb? (Tu y es allé(e) hier ?)",
      exampleEn: "Dem nga fa démb? (Did you go there yesterday?)",
      audio: "Wf-dem_nga"
    },
    'Dem na': {
      translation: "Il/Elle est allé(e)",
      translationEn: "He/She went",
      explanation: "Passé résultatif 3e personne du singulier — l'action est terminée et son résultat est encore pertinent.",
      explanationEn: "Resultative past, 3rd person singular — the action is completed and its result is still relevant.",
      example: "Dem na Touba. (Il/Elle est allé(e) à Touba.)",
      exampleEn: "Dem na Touba. (He/She went to Touba.)",
      audio: "Wf-dem_na"
    },
    'Nu dem na': {
      translation: "Nous sommes allé(e)s",
      translationEn: "We went",
      explanation: "Passé résultatif 1re personne du pluriel.",
      explanationEn: "Resultative past, 1st person plural.",
      example: "Nu dem na géej gi démb. (Nous sommes allé(e)s à la plage hier.)",
      exampleEn: "Nu dem na géej gi démb. (We went to the beach yesterday.)"
    },
    'Ngeen dem na': {
      translation: "Vous êtes allé(e)s",
      translationEn: "You (plural) went",
      explanation: "Passé résultatif 2e personne du pluriel.",
      explanationEn: "Resultative past, 2nd person plural.",
      example: "Ngeen dem na ci këram? (Vous êtes allé(e)s chez lui/elle ?)",
      exampleEn: "Ngeen dem na ci këram? (Did you go to his/her place?)"
    },
    'Nañu dem': {
      translation: "Ils/Elles sont allé(e)s",
      translationEn: "They went",
      explanation: "Passé résultatif 3e personne du pluriel.",
      explanationEn: "Resultative past, 3rd person plural.",
      example: "Nañu dem féete bi. (Ils/Elles sont allé(e)s à la fête.)",
      exampleEn: "Nañu dem féete bi. (They went to the party.)"
    },
    // ── Passé emphatique (da-) ── met en relief l'action accomplie
    'Dama dem': {
      translation: "Je suis allé(e) (focus action)",
      translationEn: "I went (action focus)",
      explanation: "Passé emphatique 1re personne — insiste sur le fait que c'est bien le sujet qui a accompli l'action.",
      explanationEn: "Emphatic past, 1st person — stresses that it is indeed the subject who performed the action.",
      example: "Dama dem marché ba. (Je suis allé(e) au marché.)",
      exampleEn: "Dama dem marché ba. (I went to the market.)",
      audio: "Wf-dama_dem"
    },
    'Danga dem': {
      translation: "Tu es allé(e) (focus action)",
      translationEn: "You went (action focus)",
      explanation: "Passé emphatique 2e personne du singulier.",
      explanationEn: "Emphatic past, 2nd person singular.",
      example: "Danga dem fa bees? (Tu es vraiment allé(e) là-bas récemment ?)",
      exampleEn: "Danga dem fa bees? (Did you really go there recently?)"
    },
    'Dafa dem': {
      translation: "Il/Elle est allé(e) (focus action)",
      translationEn: "He/She went (action focus)",
      explanation: "Passé emphatique 3e personne — insiste sur le fait que l'action a bien eu lieu.",
      explanationEn: "Emphatic past, 3rd person — stresses that the action indeed took place.",
      example: "Dafa dem rekk, waxtaan bi jeex na. (Il/Elle est simplement parti(e), la discussion est terminée.)",
      exampleEn: "Dafa dem rekk, waxtaan bi jeex na. (He/She simply left, the conversation is over.)",
      audio: "Wf-dafa_dem"
    },
    // ── Plus-que-parfait (oon) ── action antérieure à une autre action passée
    'Demoon naa': {
      translation: "J'étais allé(e)",
      translationEn: "I had gone",
      explanation: "Plus-que-parfait 1re personne du singulier. Le suffixe 'oon' marque l'antériorité dans le passé.",
      explanationEn: "Pluperfect, 1st person singular. The suffix 'oon' marks anteriority in the past.",
      example: "Demoon naa fa bala nga ñëw. (J'y étais allé(e) avant que tu ne viennes.)",
      exampleEn: "Demoon naa fa bala nga ñëw. (I had gone there before you came.)",
      audio: "Wf-demoon_naa"
    },
    'Demoon nga': {
      translation: "Tu étais allé(e)",
      translationEn: "You had gone",
      explanation: "Plus-que-parfait 2e personne du singulier.",
      explanationEn: "Pluperfect, 2nd person singular.",
      example: "Demoon nga fa bi ma agsi? (Tu y étais allé(e) quand je suis arrivé(e) ?)",
      exampleEn: "Demoon nga fa bi ma agsi? (Had you gone there when I arrived?)"
    },
    'Demoon na': {
      translation: "Il/Elle était allé(e)",
      translationEn: "He/She had gone",
      explanation: "Plus-que-parfait 3e personne du singulier.",
      explanationEn: "Pluperfect, 3rd person singular.",
      example: "Demoon na marché ba bi ma agsee. (Il/Elle était allé(e) au marché quand je suis arrivé(e).)",
      exampleEn: "Demoon na marché ba bi ma agsee. (He/She had gone to the market when I arrived.)",
      audio: "Wf-demoon_na"
    },
    // ── Passé progressif (doon) ── action en cours dans le passé
    'Dama doon dem': {
      translation: "J'étais en train d'aller",
      translationEn: "I was going",
      explanation: "Imparfait progressif 1re personne. 'Doon' est l'auxiliaire d'imparfait — il indique une action en cours au moment d'un fait passé.",
      explanationEn: "Progressive imperfect, 1st person. 'Doon' is the imperfect auxiliary — it indicates an action in progress at the time of a past event.",
      example: "Dama doon dem bi telefon bi sonnee. (J'étais en train de partir quand le téléphone a sonné.)",
      exampleEn: "Dama doon dem bi telefon bi sonnee. (I was leaving when the phone rang.)"
    },
    'Dafa doon dem': {
      translation: "Il/Elle était en train d'aller",
      translationEn: "He/She was going",
      explanation: "Imparfait progressif 3e personne du singulier.",
      explanationEn: "Progressive imperfect, 3rd person singular.",
      example: "Dafa doon dem bi ma ko woo. (Il/Elle était en train de partir quand je l'ai appelé(e).)",
      exampleEn: "Dafa doon dem bi ma ko woo. (He/She was leaving when I called him/her.)",
      audio: "Wf-dafa_doon_dem"
    },
    // ── Passés aspectuels ──
    'Demati na': {
      translation: "Il/Elle est allé(e) de nouveau",
      translationEn: "He/She went again",
      explanation: "Passé répétitif — le suffixe 'ati' exprime le retour ou la répétition d'une action.",
      explanationEn: "Repetitive past — the suffix 'ati' expresses the return or repetition of an action.",
      example: "Demati na Ndakaaru. (Il/Elle est retourné(e) à Dakar.)",
      exampleEn: "Demati na Ndakaaru. (He/She went back to Dakar.)",
      audio: "Wf-demati_na"
    },
    'Daan na dem': {
      translation: "Il/Elle avait l'habitude d'aller",
      translationEn: "He/She used to go",
      explanation: "Passé habituel — 'daan' exprime une habitude révolue, équivalent de 'used to' en anglais.",
      explanationEn: "Habitual past — 'daan' expresses a discontinued habit, equivalent to 'used to' in English.",
      example: "Daan na dem géej gi. (Il/Elle avait l'habitude d'aller à la plage.)",
      exampleEn: "Daan na dem géej gi. (He/She used to go to the beach.)",
      audio: "Wf-daan_na_dem"
    },
    'Daan naa dem': {
      translation: "J'avais l'habitude d'aller",
      translationEn: "I used to go",
      explanation: "Passé habituel 1re personne du singulier.",
      explanationEn: "Habitual past, 1st person singular.",
      example: "Daan naa dem jumaa gi léegi léegi. (J'avais l'habitude d'aller à la mosquée tout le temps.)",
      exampleEn: "Daan naa dem jumaa gi léegi léegi. (I used to go to the mosque all the time.)"
    },
  },

  'Temps verbaux — Futur': {
    'Dinaa dem': {
      translation: "J'irai",
      translationEn: "I will go",
      explanation: "Futur simple 1re personne du singulier. 'Dina' + suffixe de personne.",
      explanationEn: "Simple future, 1st person singular. 'Dina' + person suffix.",
      example: "Dinaa dem suba ci suba. (J'irai demain matin.)",
      exampleEn: "Dinaa dem suba ci suba. (I will go tomorrow morning.)",
      audio: "Wf-dinaa_dem"
    },
    'Dinga dem': {
      translation: "Tu iras",
      translationEn: "You will go",
      explanation: "Futur simple 2e personne du singulier.",
      explanationEn: "Simple future, 2nd person singular.",
      example: "Dinga dem ak ma? (Tu iras avec moi ?)",
      exampleEn: "Dinga dem ak ma? (Will you go with me?)"
    },
    'Dina dem': {
      translation: "Il/Elle ira",
      translationEn: "He/She will go",
      explanation: "Futur simple 3e personne du singulier. Forme de base du futur wolof.",
      explanationEn: "Simple future, 3rd person singular. Base form of the Wolof future.",
      example: "Dina dem école bi. (Il/Elle ira à l'école.)",
      exampleEn: "Dina dem école bi. (He/She will go to school.)",
      audio: "Wf-dina_dem"
    },
    'Dinu dem': {
      translation: "Nous irons",
      translationEn: "We will go",
      explanation: "Futur simple 1re personne du pluriel.",
      explanationEn: "Simple future, 1st person plural.",
      example: "Dinu dem Ndakaaru suba. (Nous irons à Dakar demain.)",
      exampleEn: "Dinu dem Ndakaaru suba. (We will go to Dakar tomorrow.)"
    },
    'Dingeen dem': {
      translation: "Vous irez",
      translationEn: "You (plural) will go",
      explanation: "Futur simple 2e personne du pluriel.",
      explanationEn: "Simple future, 2nd person plural.",
      example: "Dingeen dem ci këram? (Vous irez chez lui/elle ?)",
      exampleEn: "Dingeen dem ci këram? (Will you go to his/her place?)"
    },
    'Diñu dem': {
      translation: "Ils/Elles iront",
      translationEn: "They will go",
      explanation: "Futur simple 3e personne du pluriel.",
      explanationEn: "Simple future, 3rd person plural.",
      example: "Diñu dem féete bi. (Ils/Elles iront à la fête.)",
      exampleEn: "Diñu dem féete bi. (They will go to the party.)"
    },
    'Dina demoon': {
      translation: "Il/Elle serait allé(e)",
      translationEn: "He/She would have gone",
      explanation: "Conditionnel passé — action qui aurait pu se produire sous certaines conditions.",
      explanationEn: "Past conditional — an action that could have occurred under certain conditions.",
      example: "Dina demoon su amoon waxtu. (Il/Elle serait allé(e) s'il/elle avait eu le temps.)",
      exampleEn: "Dina demoon su amoon waxtu. (He/She would have gone if he/she had had time.)",
      audio: "Wf-dina_demoon"
    },
  },

  'Temps verbaux — Impératif & Conditionnel': {
    'Demal': {
      translation: "Va !",
      translationEn: "Go!",
      explanation: "Impératif 2e personne du singulier. Le suffixe '-al' marque l'impératif singulier en wolof.",
      explanationEn: "Imperative, 2nd person singular. The suffix '-al' marks the singular imperative in Wolof.",
      example: "Demal jàng! (Va étudier !)",
      exampleEn: "Demal jàng! (Go study!)",
      audio: "Wf-demal"
    },
    'Demleen': {
      translation: "Allez !",
      translationEn: "Go! (plural)",
      explanation: "Impératif 2e personne du pluriel. Le suffixe '-leen' marque l'impératif pluriel.",
      explanationEn: "Imperative, 2nd person plural. The suffix '-leen' marks the plural imperative.",
      example: "Demleen léegi! (Allez-y maintenant !)",
      exampleEn: "Demleen léegi! (Go now!)",
      audio: "Wf-demleen"
    },
    'Bul dem': {
      translation: "Ne va pas !",
      translationEn: "Don't go!",
      explanation: "Impératif négatif singulier. 'Bul' est le marqueur d'interdiction à la 2e personne du singulier.",
      explanationEn: "Negative imperative, singular. 'Bul' is the prohibition marker in the 2nd person singular.",
      example: "Bul dem ci kaw! (Ne monte pas !)",
      exampleEn: "Bul dem ci kaw! (Don't go up!)"
    },
    'Bul leen dem': {
      translation: "N'allez pas !",
      translationEn: "Don't go! (plural)",
      explanation: "Impératif négatif pluriel. 'Bul leen' interdit une action à plusieurs personnes.",
      explanationEn: "Negative imperative, plural. 'Bul leen' prohibits an action for several people.",
      example: "Bul leen dem xonk! (N'allez pas là-bas en courant !)",
      exampleEn: "Bul leen dem xonk! (Don't run over there!)"
    },
    'Su demee': {
      translation: "S'il/elle va",
      translationEn: "If he/she goes",
      explanation: "Conditionnel présent avec 'su' — exprime une hypothèse sur le présent ou le futur.",
      explanationEn: "Present conditional with 'su' — expresses a hypothesis about the present or future.",
      example: "Su demee, na wax ma. (S'il/elle y va, qu'il/elle me le dise.)",
      exampleEn: "Su demee, na wax ma. (If he/she goes, let him/her tell me.)"
    },
    'Bu demee': {
      translation: "Quand il/elle ira",
      translationEn: "When he/she goes",
      explanation: "Conditionnel/temporel futur avec 'bu' — exprime une action future conditionnelle.",
      explanationEn: "Future conditional/temporal with 'bu' — expresses a conditional future action.",
      example: "Bu demee Ndakaaru, dina indil ma yëf. (Quand il/elle ira à Dakar, il/elle m'apportera des choses.)",
      exampleEn: "Bu demee Ndakaaru, dina indil ma yëf. (When he/she goes to Dakar, he/she will bring me things.)",
      audio: "Wf-bu_demee"
    },
  },

  'Négation': {
    'Demul': {
      translation: "Il/Elle n'est pas allé(e) / n'y va pas",
      translationEn: "He/She did not go / is not going",
      explanation: "Négation du présent/passé 3e personne. Le suffixe '-ul' est la marque de négation la plus courante en wolof.",
      explanationEn: "Negation of the present/past, 3rd person. The suffix '-ul' is the most common negation marker in Wolof.",
      example: "Demul école bi tey. (Il/Elle n'est pas allé(e) à l'école aujourd'hui.)",
      exampleEn: "Demul école bi tey. (He/She did not go to school today.)",
      audio: "Wf-demul"
    },
    'Demuma': {
      translation: "Je ne suis pas allé(e)",
      translationEn: "I did not go",
      explanation: "Négation du passé 1re personne. '-uma' = -ul + ma (marque personnelle).",
      explanationEn: "Negation of the past, 1st person. '-uma' = -ul + ma (personal marker).",
      example: "Demuma féte ba. (Je ne suis pas allé(e) à la fête.)",
      exampleEn: "Demuma féte ba. (I did not go to the party.)",
      audio: "Wf-demuma"
    },
    'Demuwoon': {
      translation: "Il/Elle n'était pas allé(e)",
      translationEn: "He/She had not gone",
      explanation: "Négation du passé antérieur — combine '-ul' et 'oon' (passé).",
      explanationEn: "Negation of the past anterior — combines '-ul' and 'oon' (past).",
      example: "Demuwoon fa. (Il/Elle n'y était pas allé(e).)",
      exampleEn: "Demuwoon fa. (He/She had not gone there.)"
    },
    'Du dem': {
      translation: "Il/Elle n'ira pas",
      translationEn: "He/She will not go",
      explanation: "Négation du futur 3e personne. 'Du' est le marqueur du futur négatif.",
      explanationEn: "Negation of the future, 3rd person. 'Du' is the negative future marker.",
      example: "Du dem fête bi. (Il/Elle n'ira pas à la fête.)",
      exampleEn: "Du dem fête bi. (He/She will not go to the party.)",
      audio: "Wf-du_dem"
    },
    'Duma dem': {
      translation: "Je n'irai pas",
      translationEn: "I will not go",
      explanation: "Négation du futur 1re personne du singulier.",
      explanationEn: "Negation of the future, 1st person singular.",
      example: "Duma dem tey. (Je n'irai pas aujourd'hui.)",
      exampleEn: "Duma dem tey. (I will not go today.)",
      audio: "Wf-duma_dem"
    },
    'Dunu dem': {
      translation: "Nous n'irons pas",
      translationEn: "We will not go",
      explanation: "Négation du futur 1re personne du pluriel.",
      explanationEn: "Negation of the future, 1st person plural.",
      example: "Dunu dem ci kaw bi. (Nous n'irons pas là-haut.)",
      exampleEn: "Dunu dem ci kaw bi. (We will not go up there.)"
    },
  },

  'Questions': {
    'Lan?': {
      translation: "Quoi ? / Qu'est-ce que ?",
      translationEn: "What?",
      explanation: "'Lan' interroge sur un objet ou une chose. Se place généralement en début ou fin de proposition.",
      explanationEn: "'Lan' asks about an object or a thing. It is generally placed at the beginning or end of the clause.",
      example: "Lan nga bëgg? (Qu'est-ce que tu veux ?)",
      exampleEn: "Lan nga bëgg? (What do you want?)",
      audio: "Wf-lan"
    },
    'Kan?': {
      translation: "Qui ?",
      translationEn: "Who?",
      explanation: "'Kan' interroge sur une personne. Peut être sujet ou objet.",
      explanationEn: "'Kan' asks about a person. It can be subject or object.",
      example: "Kan moo ko def? (Qui l'a fait ?)",
      exampleEn: "Kan moo ko def? (Who did it?)",
      audio: "Wf-kan"
    },
    'Foo? / Fu?': {
      translation: "Où ?",
      translationEn: "Where?",
      explanation: "'Foo' (contraction de 'fu + yow') demande l'endroit où se trouve quelqu'un. 'Fu' seul est plus général.",
      explanationEn: "'Foo' (a contraction of 'fu + yow') asks where someone is. 'Fu' alone is more general.",
      example: "Foo dem? (Où tu vas ?)",
      exampleEn: "Foo dem? (Where are you going?)"
    },
    'Ana?': {
      translation: "Où est... ? / Il y a... ?",
      translationEn: "Where is...? / Is there...?",
      explanation: "'Ana' sert à demander où se trouve une personne ou un objet précis. Plus direct que 'fu'.",
      explanationEn: "'Ana' is used to ask where a specific person or object is. More direct than 'fu'.",
      example: "Ana sa yaay? (Où est ta maman ?)",
      exampleEn: "Ana sa yaay? (Where is your mother?)"
    },
    'Kañ?': {
      translation: "Quand ?",
      translationEn: "When?",
      explanation: "'Kañ' interroge sur le moment d'une action.",
      explanationEn: "'Kañ' asks about the time of an action.",
      example: "Kañ nga ñëw? (Quand est-ce que tu arrives ?)",
      exampleEn: "Kañ nga ñëw? (When are you arriving?)"
    },
    'Naka?': {
      translation: "Comment ?",
      translationEn: "How?",
      explanation: "'Naka' interroge sur la manière ou l'état. Aussi utilisé dans les salutations : 'Naka nga def ?' = Comment vas-tu ?",
      explanationEn: "'Naka' asks about the manner or state. Also used in greetings: 'Naka nga def?' = How are you?",
      example: "Naka nga def? (Comment vas-tu ?)",
      exampleEn: "Naka nga def? (How are you?)",
      audio: "Wf-naka"
    },
    'Ñaata?': {
      translation: "Combien ?",
      translationEn: "How much/many?",
      explanation: "'Ñaata' interroge sur une quantité ou un prix.",
      explanationEn: "'Ñaata' asks about a quantity or a price.",
      example: "Ñaata la jar? (Combien ça coûte ?)",
      exampleEn: "Ñaata la jar? (How much does it cost?)"
    },
    'Ndax...?': {
      translation: "Est-ce que... ?",
      translationEn: "Is it that...? / Do...?",
      explanation: "'Ndax' en tête de phrase transforme une affirmation en question fermée (oui/non).",
      explanationEn: "'Ndax' at the beginning of a sentence turns a statement into a closed (yes/no) question.",
      example: "Ndax danga dem démb? (Est-ce que tu y es allé hier ?)",
      exampleEn: "Ndax danga dem démb? (Did you go there yesterday?)"
    },
  },

  // ============================================================
  // UNITÉ 3 — PRÉPOSITIONS, ADJECTIFS, ADVERBES & CONJONCTIONS
  // ============================================================

  'Prépositions de lieu': {
    'Ci': {
      translation: "Dans, sur, à",
      translationEn: "In, on, at",
      explanation: "Préposition de lieu générale, utilisée pour indiquer la position ou la direction",
      explanationEn: "General locative preposition, used to indicate position or direction",
      example: "Mu ngi ci kër gi. (Il/Elle est dans la maison.)",
      exampleEn: "Mu ngi ci kër gi. (He/She is in the house.)",
      audio: "Wf-ci"
    },
    'Ca': {
      translation: "Dans, vers (éloigné)",
      translationEn: "In, towards (distant)",
      explanation: "Variante distale de 'ci', indique un lieu plus éloigné ou un mouvement vers ce lieu.",
      explanationEn: "Distal variant of 'ci', indicates a more distant place or movement towards that place.",
      example: "Dafa dem ca marché ba. (Il/Elle est allé(e) vers le marché.)",
      exampleEn: "Dafa dem ca marché ba. (He/She went towards the market.)",
      audio: "Wf-ca"
    },
    'Fi': {
      translation: "Ici",
      translationEn: "Here",
      explanation: "Adverbe de lieu indiquant la proximité immédiate du locuteur.",
      explanationEn: "Locative adverb indicating the immediate proximity of the speaker.",
      example: "Toog fi. (Assieds-toi ici.)",
      exampleEn: "Toog fi. (Sit here.)",
      audio: "Wf-fi"
    },
    'Fa': {
      translation: "Là, là-bas",
      translationEn: "There, over there",
      explanation: "Adverbe de lieu indiquant un endroit éloigné du locuteur.",
      explanationEn: "Locative adverb indicating a place far from the speaker.",
      example: "Dem fa. (Va là-bas.)",
      exampleEn: "Dem fa. (Go there.)",
      audio: "Wf-fa"
    },
    'Ci biir': {
      translation: "À l'intérieur de",
      translationEn: "Inside",
      explanation: "Locution prépositionnelle indiquant l'intériorité.",
      explanationEn: "Prepositional phrase indicating interiority.",
      example: "Yàpp bi nekk ci biir néeg bi. (La viande est à l'intérieur de la chambre.)",
      exampleEn: "Yàpp bi nekk ci biir néeg bi. (The meat is inside the room.)",
      audio: "Wf-ci_biir"
    },
    'Ci kaw': {
      translation: "Sur, au-dessus de",
      translationEn: "On, above",
      explanation: "Locution prépositionnelle indiquant une position supérieure.",
      explanationEn: "Prepositional phrase indicating a position above.",
      example: "Teg ko ci kaw taabal bi. (Mets-le sur la table.)",
      exampleEn: "Teg ko ci kaw taabal bi. (Put it on the table.)",
      audio: "Wf-ci_kaw"
    },
    'Ci ron': {
      translation: "Sous, en dessous de",
      translationEn: "Under, below",
      explanation: "Locution prépositionnelle indiquant une position inférieure.",
      explanationEn: "Prepositional phrase indicating a position below.",
      example: "Mu ngi ci ron lal bi. (Il/Elle est sous le lit.)",
      exampleEn: "Mu ngi ci ron lal bi. (He/She is under the bed.)",
      audio: "Wf-ci_ron"
    },
    'Ci wetu': {
      translation: "À côté de",
      translationEn: "Next to",
      explanation: "Locution prépositionnelle indiquant la proximité.",
      explanationEn: "Prepositional phrase indicating proximity.",
      example: "Toog ci wetu xarit bi. (Assieds-toi à côté de l'ami(e).)",
      exampleEn: "Toog ci wetu xarit bi. (Sit next to the friend.)",
      audio: "Wf-ci_wetu"
    },
    'Ci kanam': {
      translation: "Devant, en face de",
      translationEn: "In front of, facing",
      explanation: "Locution prépositionnelle indiquant une position frontale.",
      explanationEn: "Prepositional phrase indicating a frontal position.",
      example: "Taxaw ci kanam jàngal bi. (Tiens-toi devant le professeur.)",
      exampleEn: "Taxaw ci kanam jàngal bi. (Stand in front of the teacher.)",
      audio: "Wf-ci_kanam"
    },
    'Ci gannaaw': {
      translation: "Derrière",
      translationEn: "Behind",
      explanation: "Locution prépositionnelle indiquant une position à l'arrière.",
      explanationEn: "Prepositional phrase indicating a position at the back.",
      example: "Mu ngi ci gannaaw garab gi. (Il/Elle est derrière l'arbre.)",
      exampleEn: "Mu ngi ci gannaaw garab gi. (He/She is behind the tree.)",
      audio: "Wf-ci_gannaaw"
    },
    'Ci digg': {
      translation: "Au milieu de",
      translationEn: "In the middle of",
      explanation: "Locution prépositionnelle indiquant une position centrale.",
      explanationEn: "Prepositional phrase indicating a central position.",
      example: "Taxaw ci digg néeg bi. (Reste debout au milieu de la pièce.)",
      exampleEn: "Taxaw ci digg néeg bi. (Stand in the middle of the room.)",
      audio: "Wf-ci_digg"
    },
    'Ci diggu': {
      translation: "Entre",
      translationEn: "Between",
      explanation: "Locution prépositionnelle indiquant une position intermédiaire.",
      explanationEn: "Prepositional phrase indicating an intermediate position.",
      example: "Toog ci diggu Moussa ak Fatou. (Assieds-toi entre Moussa et Fatou.)",
      exampleEn: "Toog ci diggu Moussa ak Fatou. (Sit between Moussa and Fatou.)",
      audio: "Wf-ci_diggu"
    },
  },

  'Prépositions de temps et de relation': {
    'Ba': {
      translation: "Jusqu'à",
      translationEn: "Until",
      explanation: "Indique une limite dans le temps ou l'espace.",
      explanationEn: "Indicates a limit in time or space.",
      example: "Xaar ba suba. (Attends jusqu'à demain.)",
      exampleEn: "Xaar ba suba. (Wait until tomorrow.)",
      audio: "Wf-ba"
    },
    'Bala': {
      translation: "Avant de",
      translationEn: "Before",
      explanation: "Indique une action qui précède une autre.",
      explanationEn: "Indicates an action that precedes another.",
      example: "Bala nga dem, wax ma. (Avant de partir, dis-moi.)",
      exampleEn: "Bala nga dem, wax ma. (Before you leave, tell me.)",
      audio: "Wf-bala"
    },
    'Li dale': {
      translation: "Depuis",
      translationEn: "Since",
      explanation: "Indique le point de départ dans le temps.",
      explanationEn: "Indicates the starting point in time.",
      example: "Li dale suba, mu ngi liggéey. (Depuis ce matin, il/elle travaille.)",
      exampleEn: "Li dale suba, mu ngi liggéey. (Since this morning, he/she has been working.)",
      audio: "Wf-li_dale"
    },
    'Ci bir': {
      translation: "Pendant",
      translationEn: "During",
      explanation: "Indique une durée.",
      explanationEn: "Indicates a duration.",
      example: "Ci bir weer wi, dama toog fi. (Pendant ce mois, je suis resté(e) ici.)",
      exampleEn: "Ci bir weer wi, dama toog fi. (During this month, I stayed here.)",
      audio: "Wf-ci_bir"
    },
    'Ak': {
      translation: "Avec, et",
      translationEn: "With, and",
      explanation: "Indique l'accompagnement ou l'addition entre deux éléments.",
      explanationEn: "Indicates accompaniment or addition between two elements.",
      example: "Dama dem ak sama xarit. (Je suis allé(e) avec mon ami(e).)",
      exampleEn: "Dama dem ak sama xarit. (I went with my friend.)",
      audio: "Wf-ak"
    },
    'Ngir': {
      translation: "Pour, à cause de",
      translationEn: "For, because of",
      explanation: "Indique le but ou la raison d'une action.",
      explanationEn: "Indicates the purpose or reason for an action.",
      example: "Dama ko def ngir yow. (Je l'ai fait pour toi.)",
      exampleEn: "Dama ko def ngir yow. (I did it for you.)",
      audio: "Wf-ngir"
    },
    'Ndax': {
      translation: "À cause de, parce que",
      translationEn: "Because of, because",
      explanation: "Indique la cause. Attention : 'ndax' peut aussi introduire une question (voir Questions).",
      explanationEn: "Indicates cause. Note: 'ndax' can also introduce a question (see Questions).",
      example: "Ñëwuma ndax taw bi. (Je ne suis pas venu(e) à cause de la pluie.)",
      exampleEn: "Ñëwuma ndax taw bi. (I did not come because of the rain.)",
      audio: "Wf-ndax"
    },
    'Ni': {
      translation: "Comme, de la même manière que",
      translationEn: "Like, in the same way as",
      explanation: "Indique une comparaison ou une manière.",
      explanationEn: "Indicates a comparison or a manner.",
      example: "Dox ni gaynde. (Marche comme un lion.)",
      exampleEn: "Dox ni gaynde. (Walk like a lion.)"
    },
  },

  'Adjectifs — Apparence physique': {
    'Rafet': {
      translation: "Beau, belle",
      translationEn: "Beautiful, handsome",
      explanation: "Décrit une apparence agréable. En wolof, l'adjectif suit le nom et s'accorde avec la classe nominale.",
      explanationEn: "Describes a pleasant appearance. In Wolof, the adjective follows the noun and agrees with the noun class.",
      example: "Ndaw si rafet na lool. (La jeune fille est très belle.)",
      exampleEn: "Ndaw si rafet na lool. (The young girl is very beautiful.)",
      audio: "Wf-rafet"
    },
    'Buul': {
      translation: "Laid, moche",
      translationEn: "Ugly",
      explanation: "Opposé de 'rafet'.",
      explanationEn: "Opposite of 'rafet'.",
      example: "Mbubb mi buul na. (Le boubou est laid.)",
      exampleEn: "Mbubb mi buul na. (The boubou is ugly.)",
      audio: "Wf-buul"
    },
    'Rëy': {
      translation: "Gros, corpulent",
      translationEn: "Big, heavyset",
      explanation: "Décrit une forte corpulence.",
      explanationEn: "Describes a large build.",
      example: "Góor gi rëy na. (L'homme est corpulent.)",
      exampleEn: "Góor gi rëy na. (The man is heavyset.)",
      audio: "Wf-rey"
    },
    'Njool': {
      translation: "Mince, svelte",
      translationEn: "Slim, slender",
      explanation: "Décrit une faible corpulence.",
      explanationEn: "Describes a slight build.",
      example: "Janq bi njool na. (La jeune fille est svelte.)",
      exampleEn: "Janq bi njool na. (The young girl is slender.)"
    },
    'Gudd': {
      translation: "Grand, long",
      translationEn: "Tall, long",
      explanation: "Décrit la taille ou la longueur.",
      explanationEn: "Describes size or length.",
      example: "Woto bi gudd na. (La voiture est longue.)",
      exampleEn: "Woto bi gudd na. (The car is long.)",
      audio: "Wf-gudd"
    },
    'Gàtt': {
      translation: "Court, petit",
      translationEn: "Short, small",
      explanation: "Opposé de 'gudd'.",
      explanationEn: "Opposite of 'gudd'.",
      example: "Kawar bi gàtt na. (La corde est courte.)",
      exampleEn: "Kawar bi gàtt na. (The rope is short.)",
      audio: "Wf-gatt"
    },
    'Naat': {
      translation: "Large, vaste",
      translationEn: "Wide, spacious",
      explanation: "Décrit une grande étendue ou largeur.",
      explanationEn: "Describes a large area or width.",
      example: "Néeg bi naat na. (La chambre est large.)",
      exampleEn: "Néeg bi naat na. (The room is spacious.)",
      audio: "Wf-naat"
    },
    'Wànt': {
      translation: "Étroit, serré",
      translationEn: "Narrow, tight",
      explanation: "Opposé de 'naat'.",
      explanationEn: "Opposite of 'naat'.",
      example: "Yoon wi wànt na. (Le chemin est étroit.)",
      exampleEn: "Yoon wi wànt na. (The path is narrow.)"
    },
  },

  'Adjectifs — Caractère': {
    'Baax': {
      translation: "Bon, gentil",
      translationEn: "Good, kind",
      explanation: "Décrit une personne de bonne nature.",
      explanationEn: "Describes a person of good nature.",
      example: "Sama xarit baax na. (Mon ami est gentil.)",
      exampleEn: "Sama xarit baax na. (My friend is kind.)",
      audio: "Wf-baax"
    },
    'Soxor': {
      translation: "Généreux, charitable",
      translationEn: "Generous, charitable",
      explanation: "Décrit une personne qui aime donner.",
      explanationEn: "Describes a person who likes to give.",
      example: "Ndaw si soxor na. (La jeune femme est généreuse.)",
      exampleEn: "Ndaw si soxor na. (The young woman is generous.)",
      audio: "Wf-soxor"
    },
    'Naqari': {
      translation: "Intelligent, futé",
      translationEn: "Intelligent, clever",
      explanation: "Décrit une personne douée intellectuellement.",
      explanationEn: "Describes an intellectually gifted person.",
      example: "Xale bi naqari na. (L'enfant est intelligent.)",
      exampleEn: "Xale bi naqari na. (The child is intelligent.)"
    },
    'Muñ': {
      translation: "Patient",
      translationEn: "Patient",
      explanation: "Décrit une personne qui sait attendre calmement.",
      explanationEn: "Describes a person who knows how to wait calmly.",
      example: "Jàngalekat bi muñ na. (Le professeur est patient.)",
      exampleEn: "Jàngalekat bi muñ na. (The teacher is patient.)",
      audio: "Wf-mun"
    },
    'Jom': {
      translation: "Courageux, brave",
      translationEn: "Courageous, brave",
      explanation: "Décrit une personne qui n'a pas peur.",
      explanationEn: "Describes a person who is not afraid.",
      example: "Xale bi am na jom. (L'enfant est courageux.)",
      exampleEn: "Xale bi am na jom. (The child is courageous.)",
      audio: "Wf-jom"
    },
    'Wóor': {
      translation: "Honnête, intègre",
      translationEn: "Honest, upright",
      explanation: "Décrit une personne droite et sincère.",
      explanationEn: "Describes an upright and sincere person.",
      example: "Góor gi wóor na. (L'homme est honnête.)",
      exampleEn: "Góor gi wóor na. (The man is honest.)"
    },
    'Taqale': {
      translation: "Poli, courtois",
      translationEn: "Polite, courteous",
      explanation: "Décrit une personne aux manières raffinées.",
      explanationEn: "Describes a person with refined manners.",
      example: "Xale bi taqale na. (L'enfant est poli.)",
      exampleEn: "Xale bi taqale na. (The child is polite.)"
    },
    'Wooral': {
      translation: "Paresseux, fainéant",
      translationEn: "Lazy, idle",
      explanation: "Décrit un manque de motivation à agir.",
      explanationEn: "Describes a lack of motivation to act.",
      example: "Xale bi wooral na. (L'enfant est paresseux.)",
      exampleEn: "Xale bi wooral na. (The child is lazy.)"
    },
  },

  'Adjectifs — États et sensations': {
    'Tàng': {
      translation: "Chaud",
      translationEn: "Hot",
      explanation: "Décrit la sensation de chaleur.",
      explanationEn: "Describes the sensation of heat.",
      example: "Ndox mi tàng na. (L'eau est chaude.)",
      exampleEn: "Ndox mi tàng na. (The water is hot.)",
      audio: "Wf-tang"
    },
    'Sedd': {
      translation: "Froid, frais",
      translationEn: "Cold, cool",
      explanation: "Décrit la sensation de fraîcheur.",
      explanationEn: "Describes the sensation of coolness.",
      example: "Nden gi sedd na. (La boisson est fraîche.)",
      exampleEn: "Nden gi sedd na. (The drink is cool.)",
      audio: "Wf-sedd"
    },
    'Xiif': {
      translation: "Affamé",
      translationEn: "Hungry",
      explanation: "Décrit l'état d'avoir faim.",
      explanationEn: "Describes the state of being hungry.",
      example: "Dama xiif. (J'ai très faim.)",
      exampleEn: "Dama xiif. (I am very hungry.)",
      audio: "Wf-xiif"
    },
    'Waar': {
      translation: "Épuisé, exténué",
      translationEn: "Exhausted, worn out",
      explanation: "Décrit un état de fatigue extrême.",
      explanationEn: "Describes a state of extreme fatigue.",
      example: "Liggéeykat bi waar na. (Le travailleur est épuisé.)",
      exampleEn: "Liggéeykat bi waar na. (The worker is exhausted.)"
    },
    'Neex': {
      translation: "Délicieux, agréable",
      translationEn: "Delicious, pleasant",
      explanation: "Décrit quelque chose d'agréable au goût ou à l'expérience.",
      explanationEn: "Describes something pleasant in taste or experience.",
      example: "Ceebu jën bi neex na. (Le thiéboudienne est délicieux.)",
      exampleEn: "Ceebu jën bi neex na. (The thiéboudienne is delicious.)",
      audio: "Wf-neex"
    },
    'Tiis': {
      translation: "Lisse, poli",
      translationEn: "Smooth, polished",
      explanation: "Décrit une surface régulière et douce.",
      explanationEn: "Describes a smooth, even surface.",
      example: "Xeer bi tiis na. (La pierre est lisse.)",
      exampleEn: "Xeer bi tiis na. (The stone is smooth.)"
    },
    'Tooy': {
      translation: "Rugueux, râpeux",
      translationEn: "Rough, coarse",
      explanation: "Décrit une surface non lisse au toucher.",
      explanationEn: "Describes a surface that is not smooth to the touch.",
      example: "Bant bi tooy na. (Le bois est rugueux.)",
      exampleEn: "Bant bi tooy na. (The wood is rough.)",
      audio: "Wf-tooy"
    },
    'Saf': {
      translation: "Propre, pur",
      translationEn: "Clean, pure",
      explanation: "Décrit quelque chose de propre et sans tache.",
      explanationEn: "Describes something clean and stainless.",
      example: "Mbubb mi saf na. (Le boubou est propre.)",
      exampleEn: "Mbubb mi saf na. (The boubou is clean.)",
      audio: "Wf-saf"
    },
  },

  'Adjectifs — Quantité et jugement': {
    'Bëri': {
      translation: "Nombreux, abondant",
      translationEn: "Numerous, abundant",
      explanation: "Décrit une grande quantité.",
      explanationEn: "Describes a large quantity.",
      example: "Nit ñi bëri nañu. (Les gens sont nombreux.)",
      exampleEn: "Nit ñi bëri nañu. (The people are numerous.)",
      audio: "Wf-beri"
    },
    'Néew': {
      translation: "Rare, peu nombreux",
      translationEn: "Rare, scarce",
      explanation: "Décrit une faible quantité.",
      explanationEn: "Describes a small quantity.",
      example: "Ndox mi néew na. (L'eau est rare.)",
      exampleEn: "Ndox mi néew na. (The water is scarce.)",
      audio: "Wf-neew"
    },
    'Yomb': {
      translation: "Facile, aisé",
      translationEn: "Easy, simple",
      explanation: "Décrit quelque chose de simple à réaliser.",
      explanationEn: "Describes something simple to do.",
      example: "Liggéey bi yomb na. (Le travail est facile.)",
      exampleEn: "Liggéey bi yomb na. (The work is easy.)"
    },
    'Jafé': {
      translation: "Difficile, ardu",
      translationEn: "Difficult, arduous",
      explanation: "Décrit quelque chose de compliqué à réaliser.",
      explanationEn: "Describes something complicated to do.",
      example: "Jaaxal bi jafé na. (Le problème est difficile.)",
      exampleEn: "Jaaxal bi jafé na. (The problem is difficult.)",
      audio: "Wf-jafe"
    },
    'Bees': {
      translation: "Nouveau, neuf",
      translationEn: "New",
      explanation: "Décrit quelque chose de récent ou qui n'a pas encore servi.",
      explanationEn: "Describes something recent or not yet used.",
      example: "Téere bi bees na. (Le livre est neuf.)",
      exampleEn: "Téere bi bees na. (The book is new.)",
      audio: "Wf-bees"
    },
    'Ndaw': {
      translation: "Jeune, juvénile",
      translationEn: "Young, youthful",
      explanation: "Relatif à la jeunesse.",
      explanationEn: "Relating to youth.",
      example: "Góor gi ndaw na. (L'homme est jeune.)",
      exampleEn: "Góor gi ndaw na. (The man is young.)",
      audio: "Wf-ndaw"
    },
    'Màggat': {
      translation: "Vieux, âgé",
      translationEn: "Old, elderly",
      explanation: "Relatif à un âge avancé ou une longue durée.",
      explanationEn: "Relating to an advanced age or a long duration.",
      example: "Yaay bi màggat na. (La mère est âgée.)",
      exampleEn: "Yaay bi màggat na. (The mother is elderly.)",
      audio: "Wf-maggat"
    },
    'Gawe': {
      translation: "Rapide, précoce",
      translationEn: "Fast, early",
      explanation: "Décrit un rythme rapide ou quelque chose arrivé plus tôt que prévu.",
      explanationEn: "Describes a fast pace or something that happened earlier than expected.",
      example: "Mu ngi gawe ci liggéey bi. (Il/Elle est rapide au travail.)",
      exampleEn: "Mu ngi gawe ci liggéey bi. (He/She is fast at work.)",
      audio: "Wf-gawe"
    },
  },

  'Conjonctions': {
    'Ak': {
      translation: "Et, avec",
      translationEn: "And, with",
      explanation: "'Ak' relie deux noms ou deux groupes nominaux. Attention : il ne relie pas deux phrases complètes (pour ça, utiliser 'te').",
      explanationEn: "'Ak' connects two nouns or two noun phrases. Note: it does not connect two complete sentences (for that, use 'te').",
      example: "Moussa ak Fatou ñu dem. (Moussa et Fatou sont partis.)",
      exampleEn: "Moussa ak Fatou ñu dem. (Moussa and Fatou have left.)"
    },
    'Te': {
      translation: "Et (reliant deux propositions)",
      translationEn: "And (connecting two clauses)",
      explanation: "'Te' relie deux propositions complètes, équivalent de 'et puis' en français.",
      explanationEn: "'Te' connects two complete clauses, equivalent to 'and then' in French.",
      example: "Dama lekk te dama naan. (J'ai mangé et j'ai bu.)",
      exampleEn: "Dama lekk te dama naan. (I ate and I drank.)"
    },
    'Waaye': {
      translation: "Mais",
      translationEn: "But",
      explanation: "'Waaye' introduit une opposition ou une nuance.",
      explanationEn: "'Waaye' introduces an opposition or a nuance.",
      example: "Dama bëgg dem, waaye duma mën. (Je veux partir, mais je ne peux pas.)",
      exampleEn: "Dama bëgg dem, waaye duma mën. (I want to leave, but I cannot.)"
    },
    'Ndax': {
      translation: "Parce que, car",
      translationEn: "Because, for",
      explanation: "'Ndax' introduit une proposition causale. Il peut aussi introduire une question (voir Questions).",
      explanationEn: "'Ndax' introduces a causal clause. It can also introduce a question (see Questions).",
      example: "Demuma ndax waar naa. (Je ne suis pas parti(e) parce que j'étais fatigué(e).)",
      exampleEn: "Demuma ndax waar naa. (I did not leave because I was tired.)"
    },
    'Xanaa': {
      translation: "Peut-être que, il se peut que",
      translationEn: "Maybe, it might be that",
      explanation: "'Xanaa' exprime le doute ou la supposition.",
      explanationEn: "'Xanaa' expresses doubt or supposition.",
      example: "Xanaa dina ñëw suba. (Il/Elle viendra peut-être demain.)",
      exampleEn: "Xanaa dina ñëw suba. (He/She might come tomorrow.)"
    },
    'Su': {
      translation: "Si (conditionnel)",
      translationEn: "If (conditional)",
      explanation: "'Su' introduit une condition hypothétique au présent ou futur.",
      explanationEn: "'Su' introduces a hypothetical condition in the present or future.",
      example: "Su amna waxtu, dinaa dem. (Si j'ai le temps, j'irai.)",
      exampleEn: "Su amna waxtu, dinaa dem. (If I have time, I will go.)"
    },
    'Bi': {
      translation: "Quand (passé)",
      translationEn: "When (past)",
      explanation: "'Bi' introduit une proposition temporelle passée.",
      explanationEn: "'Bi' introduces a past temporal clause.",
      example: "Bi ma agsee, demoon na. (Quand je suis arrivé(e), il/elle était déjà parti(e).)",
      exampleEn: "Bi ma agsee, demoon na. (When I arrived, he/she had already left.)"
    },
    'Bu': {
      translation: "Quand (futur/habituel)",
      translationEn: "When (future/habitual)",
      explanation: "'Bu' introduit une proposition temporelle future ou habituelle.",
      explanationEn: "'Bu' introduces a future or habitual temporal clause.",
      example: "Bu ñëwee, woo ma. (Quand il/elle arrive, appelle-moi.)",
      exampleEn: "Bu ñëwee, woo ma. (When he/she arrives, call me.)"
    },
  },

  'Adverbes': {
    'Lool': {
      translation: "Très, beaucoup",
      translationEn: "Very, a lot",
      explanation: "'Lool' est l'intensificateur le plus courant en wolof. Il se place toujours après l'adjectif ou le verbe qu'il intensifie.",
      explanationEn: "'Lool' is the most common intensifier in Wolof. It is always placed after the adjective or verb it intensifies.",
      example: "Dafa rafet lool. (Elle est très belle.)",
      exampleEn: "Dafa rafet lool. (She is very beautiful.)"
    },
    'Rekk': {
      translation: "Seulement, juste",
      translationEn: "Only, just",
      explanation: "'Rekk' est un restrictif qui limite la portée du terme précédent.",
      explanationEn: "'Rekk' is a restrictive that limits the scope of the preceding term.",
      example: "Dama dem rekk. (Je suis juste passé / Je suis allé seulement.)",
      exampleEn: "Dama dem rekk. (I just stopped by / I only went.)"
    },
    'Dëkk': {
      translation: "Vraiment, certainement",
      translationEn: "Really, certainly",
      explanation: "'Dëkk' renforce l'affirmation, insiste sur la vérité d'un fait.",
      explanationEn: "'Dëkk' reinforces the statement, insisting on the truth of a fact.",
      example: "Dafa baax dëkk. (Il est vraiment bon.)",
      exampleEn: "Dafa baax dëkk. (He is really good.)"
    },
    'Sax': {
      translation: "Même, aussi",
      translationEn: "Even, too",
      explanation: "'Sax' ajoute une nuance d'inclusion ou de surprise.",
      explanationEn: "'Sax' adds a nuance of inclusion or surprise.",
      example: "Man sax duma dem. (Moi non plus je n'irai pas / Même moi je n'y vais pas.)",
      exampleEn: "Man sax duma dem. (I won't go either / Even I am not going.)"
    },
    'Léegi': {
      translation: "Maintenant, tout de suite",
      translationEn: "Now, right away",
      explanation: "'Léegi' situe l'action dans le moment présent ou immédiat.",
      explanationEn: "'Léegi' places the action in the present or immediate moment.",
      example: "Ñëw léegi! (Viens tout de suite !)",
      exampleEn: "Ñëw léegi! (Come right now!)"
    },
    'Tey': {
      translation: "Aujourd'hui",
      translationEn: "Today",
      explanation: "Adverbe de temps situant l'action dans la journée en cours.",
      explanationEn: "Time adverb placing the action within the current day.",
      example: "Tey laa ko gis. (C'est aujourd'hui que je l'ai vu.)",
      exampleEn: "Tey laa ko gis. (It is today that I saw him/her.)",
      audio: "Wf-tey"
    },
    'Démb': {
      translation: "Hier",
      translationEn: "Yesterday",
      explanation: "Adverbe de temps désignant le jour précédent.",
      explanationEn: "Time adverb designating the previous day.",
      example: "Dem na démb. (Il/Elle est parti(e) hier.)",
      exampleEn: "Dem na démb. (He/She left yesterday.)",
      audio: "Wf-demb"
    },
    'Suba': {
      translation: "Demain / Ce matin",
      translationEn: "Tomorrow / This morning",
      explanation: "'Suba' peut désigner demain ou le matin selon le contexte.",
      explanationEn: "'Suba' can mean tomorrow or morning depending on context.",
      example: "Dinaa dem suba. (J'irai demain.)",
      exampleEn: "Dinaa dem suba. (I will go tomorrow.)",
      audio: "Wf-suba"
    },
    'Ndank ndank': {
      translation: "Doucement, peu à peu",
      translationEn: "Slowly, little by little",
      explanation: "Adverbe de manière exprimant la lenteur ou la progressivité.",
      explanationEn: "Manner adverb expressing slowness or gradualness.",
      example: "Jàng ndank ndank. (Apprends doucement, pas à pas.)",
      exampleEn: "Jàng ndank ndank. (Learn slowly, step by step.)"
    },
  },

};

export default grammaire;

export {};
